import Dots from "./Dots";

export default Dots;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/Dots/index.js